import * as Yup from "yup";

export const roughModulationReportSchema = Yup.object({

    startDate: Yup.string().required("Please select start date"),
    endDate: Yup.string().required("Please select end date"),
    


});